/* searchtoggle */
$(function() {
    var searchToggle = $('.searchToggleTrigger');
    var searchBar = $('.searchBarElement');
    var searchBarFocusElement = $('.searchBarFocus');
    var wrapper = $('.wrapper');
    var searchBarHidden = true;

    searchBarFocusElement.focus(function(event) {
        $('.navwrap').addClass('__searchactive')
        $('.header-main').addClass('__searchactive')
    }).blur(function(event){
        $('.navwrap').removeClass('__searchactive')
        $('.header-main').removeClass('__searchactive')
    });
});
